<template>
	<performance-review-report :performance-review="performanceReview"></performance-review-report>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import PerformanceReviewReport from '@/components/performanceReview/PerformanceReviewReport';

	export default {
		name: 'PagePerformanceReviewReport',
		props: {
			id: {
				required: true
			}
		},
		components: {
			PerformanceReviewReport
		},
		data() {
			return {};
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			}),
			performanceReview() {
				return this.$store.state.performanceReviews.performanceReviews.find(pr => pr.id == this.id);
			},
			hasAccess() {
				// if(this.performanceReview != null){
				//     let employeeId = null;
				//     if(this.version == 'Employee')
				//         employeeId = this.performanceReview.employee.id;
				//     else if (this.version == 'Reviewer')
				//         employeeId = this.performanceReview.reviewer.id;

				//     return this.loggedInEmployee.id==employeeId;
				// }
				return false;
			}
		},
		methods: {
			cancel() {
				window.history.back();
			}
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Performance Review Report');
		}
	};
</script>

<style></style>
